import { render } from "./ChannelComponent.vue?vue&type=template&id=df4d8a0e"
import script from "./ChannelComponent.vue?vue&type=script&lang=js"
export * from "./ChannelComponent.vue?vue&type=script&lang=js"

import "./ChannelComponent.vue?vue&type=style&index=0&id=df4d8a0e&lang=css"

import exportComponent from "/Users/mac/MyDev/3-READY/v2t/vid2text/youtest.ru/youtest-front-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__